<template>
  <BaseInput
    v-bind="$attrs"
    :label="label"
    :rules="emailRule"
    :required="required"
    type="email"
  />
</template>

<script setup lang="ts">
import { string } from 'yup'
import { computed } from 'vue'
import BaseInput from '~/base/components/input/Input.vue'

const props = defineProps({
  label: { type: String, default: 'E-Mail' },
  required: { type: Boolean, default: false }
})

const emailRule = computed(() => {
  return props.required ? string().email().required() : string().email()
})
</script>
